export enum UserRole {
  MANAGER = 'Manager',
  FIELDWORKER = 'Field worker',
  BACKOFFICE_ADMIN = 'Backoffice admin',
  TEAMMATE = 'Teammate',
}
